module.exports = __webpack_public_path__ + "static/media/starProduct1.a7e95e19.png";